import chineseMessages from "@haxqer/ra-language-chinese";
import polyglotI18nProvider from "ra-i18n-polyglot";
import type { TranslationMessages } from "ra-core";

const customMessages: Record<string, string> = {
    "pushSucceeded": "推送成功",
    "pushFailed": "推送失败",
    "pushPartiallyFailed": "部分推送失败",
    "stationCreated": "站点创建成功",
    "stationCreateFailed": "站点创建失败",
    "invalidPhoneNumber": "请输入有效的联系电话",
    "tagCreated": "标签创建成功",
    "tagCreateFailed": "标签创建失败",
    "thirdDataRequestSelectClientFirst": "请选择客户端",
    "thirdDataRequestSelectDriversFirst": "请选择司机",
    "thirdDataRequestSubmitted": "创建请求已提交",
    "thirdDataRequestSubmitFailed": "创建失败",
    // Other custom translations...
};

const messages: Record<string, TranslationMessages> = {
    'zh_CN': {
        ...chineseMessages,
        ...customMessages,
    } as TranslationMessages,
    // Other languages...
};

export const i18nProvider = polyglotI18nProvider(
    (locale) => messages[locale] ?? messages.zh_CN,
    "zh_CN"
);
